import React from 'react';
import './pagination.css';
import { useSelector } from "react-redux";

const Pagination = ({ handler }) => {
    const pagination = useSelector(state => state.pagination);

    return (
        <div className="pagination">
            <div
                className={ `pagination__item pagination__item--first ${ pagination.first === null ? 'pagination__item--inactive' : '' }` }
                onClick={ () => handler(pagination.first) }
            />
            <div
                className={ `pagination__item pagination__item--prev ${ pagination.prev === null ? 'pagination__item--inactive' : '' }` }
                onClick={ () => handler(pagination.prev) }
            />
            <div className="pagination__item pagination__item--current">{ pagination.current }</div>
            <div
                className={ `pagination__item pagination__item--next ${ pagination.next === null ? 'pagination__item--inactive' : '' }`}
                onClick={ () => handler(pagination.next) }
            />
            <div
                className={ `pagination__item pagination__item--last ${ pagination.last === null ? 'pagination__item--inactive' : '' }`}
                onClick={ () => handler(pagination.last) }
            />
        </div>
    );
};

export default Pagination;